import { render, staticRenderFns } from "./AccessCards.vue?vue&type=template&id=8f9de834&scoped=true"
import script from "./AccessCards.vue?vue&type=script&lang=js"
export * from "./AccessCards.vue?vue&type=script&lang=js"
import style0 from "./AccessCards.vue?vue&type=style&index=0&id=8f9de834&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f9de834",
  null
  
)

export default component.exports